const PhotoSwipe = window.PhotoSwipe
const PhotoSwipeLightbox = window.PhotoSwipeLightbox

export class ProductPhotoSwipe extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    if (!this.els?.link?.exists) return

    this.photoSwipeInstance = new PhotoSwipeLightbox({
      loop: false,
      showAnimationDuration: 500,
      scaleMode: 'zoom',

      gallery: this,
      children: this.els.link.selector,
      bgOpacity: 1,
      arrowPrev: false,
      arrowNext: false,
      zoom: false,
      close: false,
      counter: true,
      preloadFirstSlide: true,
      closeOnVerticalDrag: true,
      tapAction: 'zoom',

      pswpModule: () => {
        return PhotoSwipe
      },
    })

    this.setupPhotoSwipeListeners()
    this.photoSwipeInstance.init()
  }

  setupListeners () {
    super.setupListeners()
  }

  setupPhotoSwipeListeners () {
    this.photoSwipeInstance.on('uiRegister', () => {
      this.addCloseButton()
      this.addDots()
    })

    this._pswpKeyHandler = (event) => {
      const pswp = this.photoSwipeInstance.pswp
      if (!pswp || !pswp.currSlide) return

      if (event.key === '+') {
        const scale = Math.min(
          pswp.currSlide.currZoomLevel + 0.25,
          pswp.currSlide.zoomLevels.max,
        )
        pswp.zoomTo(
          scale,
          { x: pswp.viewportSize.x / 2, y: pswp.viewportSize.y / 2 },
          300,
        )
      }

      if (event.key === '-') {
        const scale = Math.max(
          pswp.currSlide.currZoomLevel - 0.25,
          pswp.currSlide.zoomLevels.min,
        )
        pswp.zoomTo(
          scale,
          { x: pswp.viewportSize.x / 2, y: pswp.viewportSize.y / 2 },
          300,
        )
      }
    }

    this.photoSwipeInstance.on('afterInit', () => {
      document.addEventListener('keydown', this._pswpKeyHandler)
    })

    this.photoSwipeInstance.on('destroy', () => {
      document.removeEventListener('keydown', this._pswpKeyHandler)
    })
  }

  addCloseButton () {
    this.photoSwipeInstance.pswp.ui.registerElement({
      name: 'custom-close',
      className: 'pswp-Action_Close',
      ariaLabel: 'Close image gallery zoom',
      order: 2,
      isButton: true,
      html: this.closeSvg,
      onClick: () => {
        this.photoSwipeInstance.pswp.close()
      },
    })
  }

  addDots () {
    this.photoSwipeInstance.pswp.ui.registerElement({
      name: 'dots',
      className: 'pswp-Action_Dots',
      appendTo: 'wrapper',
      onInit: (element, pswp) => {
        const dotEls = []
        let thumbEl
        let dotEl
        let previousIndex = -1

        for (let i = 0; i < pswp.getNumItems(); i++) {
          dotEl = document.createElement('button')
          dotEl.type = 'button'
          dotEl.className = 'pswp-Action_Dot'
          dotEl.setAttribute('aria-label', `Go to slide ${i + 1}`)
          dotEl.onclick = (event) => {
            pswp.goTo(dotEls.indexOf(event.target))
          }

          thumbEl = document.createElement('img')
          thumbEl.className = 'pswp-Action_DotImage'
          thumbEl.src = this.els.link.elements[i].dataset.thumbImage

          dotEl.appendChild(thumbEl)
          element.appendChild(dotEl)

          dotEls.push(dotEl)
        }

        pswp.on('change', () => {
          if (previousIndex >= 0) {
            dotEls[previousIndex].setAttribute('aria-current', 'false')
          }
          dotEls[pswp.currIndex].setAttribute('aria-current', 'true')
          previousIndex = pswp.currIndex
        })
      },
    })
  }

  get closeSvg () {
    return `
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
        <path stroke="currentColor" stroke-width="2" d="M6.336 6.344 17.65 17.657"/>
        <path stroke="currentColor" stroke-width="2" d="M6.344 17.655 17.657 6.342"/>
      </svg>
    `
  }
}

if (!customElements.get('product-photoswipe')) {
  customElements.define('product-photoswipe', ProductPhotoSwipe)
}
